import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/views/routes/HomePage.vue'
import WalletPage from '@/views/routes/WalletPage.vue'
import TradePage from '@/views/routes/TradePage.vue'
import ClaimPage from '@/views/routes/ClaimPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  scrollBehavior() { return { x: 0, y: 0 } },
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', component: HomePage },
    { path: '/wallet', component: WalletPage },
    { path: '/trade', component: TradePage },
    { path: '/claim', component: ClaimPage }
  ]
})
